// This is the parent component of a modal: ModalAdminaccountsone

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DeleteModal from "./DeleteModal";
import GenericModal from "./GenericModal";
import ModalAdminaccountsone from "./ModalAdminaccountsone";
import Navbar from "./Navbar";
import {
  deleteAdminaccounts,
  fetchAdminaccountsItems,
} from "./redux/slices/AdminaccountsThunks";

export default function Adminaccountsone() {
  // Modal logic goes here for Adminaccountsone
  const dispatch = useDispatch();
  const admin = useSelector((state) => state.adminaccounts.items);
  const [showData, setShowData] = useState([]);
  const [allShowData, setAllShowData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [active, setActive] = useState({});

  const openModal = () => setIsModalOpen(true);
  const closeModal = async () => {
    await getAdmins();
    setIsModalOpen(false);
  };

  const openEditModal = () => setIsEditModalOpen(true);
  const closeEditModal = async () => {
    await getAdmins();
    setIsEditModalOpen(false);
  };

  const editClick = (key, item) => {
    setActive(item);
    openEditModal();
  };

  const openDeleteModal = (item) => {
    setActive(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = async () => {
    await getAdmins();
    setIsDeleteModalOpen(false);
  };

  const deleteClick = async () => {
    await dispatch(deleteAdminaccounts(active));
    closeDeleteModal();
  };

  useEffect(() => {
    if (allShowData.length > 0) {
      const filtered = allShowData.filter((val) =>
        val.email.toLowerCase()?.includes(search.toLowerCase())
      );

      setShowData(filtered);
    }
  }, [search, admin]);

  useEffect(() => {
    if (admin.length > 0) {
      const tableColumns = [
        { key: "email", width: "40%" },
        { key: "type", width: "40%" },
        { key: "faq_action", width: "40%" },
      ];

      const tableData =
        admin.length > 0
          ? admin.map((val, idx) => {
              return {
                _id: val?._id,
                email: val.email ? val.email : "",
                type: val.type ? val.type : "",
                password: val?.password ? val?.password : "",
              };
            })
          : [];
      setTableColumn(tableColumns);
      setShowData(tableData);
      setAllShowData(tableData);
    } else {
      setShowData([]);
      setAllShowData([]);
    }
  }, [admin]);

  const getAdmins = () => {
    try {
      dispatch(fetchAdminaccountsItems());
      const tableHeaders = [
        { label: "Email", width: "40%" },
        { label: "Type", width: "40%" },
        { label: "Action", width: "40%" },
      ];
      setTableHeader(tableHeaders);
    } catch (e) {
      console.log(e, "error");
    }
  };

  useEffect(() => {
    getAdmins();
  }, []);

  return (
    <RootWrapperAdminaccountsone>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Admin - Accounts</WelcomeJames>
              </Frame1462>
              <Frame1461>
                <AIMEButton
                  size="small"
                  onClick={() => openModal()}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Add
                  </span>
                </AIMEButton>
              </Frame1461>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>All</Title>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>
              <PRTNR.TableComponent
                data={showData}
                tableColumn={tableColumn}
                tableHeader={tableHeader}
                editClick={editClick}
                deleteClick={openDeleteModal}
              />
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminaccountsone
          isOpen={isModalOpen}
          onClose={closeModal}
          handler={getAdmins}
        />
      </GenericModal>
      <GenericModal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <ModalAdminaccountsone
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          type="Edit"
          active={active}
        />
      </GenericModal>
      <GenericModal isOpen={isDeleteModalOpen} onClose={closeDeleteModal}>
        <DeleteModal
          isOpen={isDeleteModalOpen}
          onDelete={deleteClick}
          itemName={"Admin"}
        />
      </GenericModal>
    </RootWrapperAdminaccountsone>
  );
}

const RootWrapperAdminaccountsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 772px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
